// extracted by mini-css-extract-plugin
export default {"CalendarMobileWidget":"CalendarMobileWidget_CalendarMobileWidget__lMTTX","EventsList":"CalendarMobileWidget_EventsList__talaV"};